import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UserTrackingService } from '../../../@core/utils';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
})
export class FooterComponent {

  constructor(private userTrackingService: UserTrackingService){}

  private cmsbase_url = environment.CMSURL_IMG
  imageUrl = this.cmsbase_url+'wp-content/uploads/2025/05/white-logo.png';


  navigateTo(link: string) {
    if (link === "feed" || link=== "/feed") {
      window.open("https://ltts.lrmer.com/", "_blank");
    }
  }

  openLink(url: string, name: string) {
    window.open(url, '_blank');
    this.userTrackingService.track('FooterLink_Clicked', {'value': name}, 'Footer');
  }

  privacyclick(){
    this.userTrackingService.track('FooterLink_Clicked', {'value':'Privacy_Policy'}, 'Footer');
  }

  copyrightclick(){
    this.userTrackingService.track('FooterLink_Clicked', {'value':'CopyRights'}, 'Footer');
  }
}
